import { ActionIcon, Box, Button, Checkbox, Group, Input, Menu, Modal, Popover, Select, Text, Tooltip } from '@mantine/core';
import { ListViewOption } from 'core/components/listToggle/listToggleControl';
import { selectSample, selectSamples } from 'modules/Warehouse/warehouseSlice';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CheckboxDropdown, ColumnFilterMenu, FilterButton } from 'core/components';
import { logger } from 'utils/logger';
import { AppConstants, CompanyTableColumns, SeasonActions, SessionActions, ViewModes } from 'utils/constants';
import { IconChevronDown, IconChevronRight, IconDatabaseImport, IconEdit, IconFileSymlink, IconFolderPlus, IconPlus, IconSearch, IconTableExport, IconTrash, IconX } from '@tabler/icons-react';
import SampleList from 'modules/Warehouse/features/samples/SampleList';
import SampleGrid from 'modules/Warehouse/features/samples/SampleGrid';
import SampleEdit from 'modules/Warehouse/features/sample/SampleEdit';
import SamplesUpload from 'modules/Warehouse/features/samples/SamplesUpload';
import {
    batchUpdateStyles,
    createSession,
    fetchSeasonDocumentsSuccess,
    fetchSeasonStyles,
    fetchSeasonStylesSuccess,
    getSeasonSuccess,
    importMastersStyles,
    importMastersStylesToSeasonSuccess,
    removeStylesFromSeason,
    setDisplayPrefs,
    setSeasonSampleFilters,
    updateSeasonStyle,
} from 'modules/Seasons/seasonSlice';
import { closeAllModals, openConfirmModal, openModal } from '@mantine/modals';
import { EmptyState } from 'core/components/emptyState/EmptyState';
import { SampleEventType } from 'core/models/SampleModel';
import { SeasonEventType } from 'core/models/SeasonModel';
import SessionEdit from 'modules/Sessions/features/session/SessionEdit';
import { selectSession } from 'modules/Sessions/sessionSlice';
import { SessionModel } from 'core/models';
import {
    appendAssocParentsForFilteredChildren,
    buildOtbFilterHelpers,
    generateColKeys,
    getCompany,
    getSampleOtbRaw,
    isGroupShotShellWithOnlyOtbChildren,
    isSampleOtbSet,
    parseSampleOtbMoment,
    organiseGroupShots,
    selectItems,
} from 'utils/helper';
import AssignToSession from './AssignToSession';
import { showNotification } from '@mantine/notifications';
import StyleEdit from 'modules/Styles/features/style/StyleEdit';
import { useAbortController } from 'core/hooks/useAbortableController';
import moment from 'moment';
import { useLocalStorage } from '@mantine/hooks';
import { SampleFilterModel } from 'core/models/SampleFilterModel';
import BatchSeasonStyleEdit from './BatchSeasonStyleEdit';
import MastersStyleImport from './MastersStyleImport';
import FilterPanel from './SeasonStyleFilterPanel';
import GroupShotEdit from './GroupShotEdit';
import _ from 'lodash';
import AddStyleToGroupShot from './AddStyleToGroupShot';
import CSVGenerator from 'core/components/csvGenerator/CsvGenerator';

const SeasonTabStyles = ({ user, season, selectedSamples, success, error, onStatusClick, aggData, sampleFilters, setSampleFilters, displayPrefs, setDisplayPrefs }) => {
    const dispatch = useDispatch();
    const [filterOpen, setFilterOpen] = useState(false);
    const [listView, setListView] = useState(ListViewOption.LIST);
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedItems, setSelectedItems] = useState(selectedSamples);
    const [filterCount, setFilterCount] = useState(0);
    const [sampleData, setSampleData] = useState([]);
    // const [sampleFilter, setSampleFilter] = useState({ ...SampleFilterModel });
    const [filterItems, setFilterItems] = useState(null);
    const [sampleModalOpen, setSampleModalOpen] = useState(false);
    const [sampleImportModalOpen, setSampleImportModalOpen] = useState(false);
    const [sampleUploadShown, setSampleUploadShown] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const company = getCompany(aggData);
    // const [columns, setColumns] = useState([...defaultColumns]);

    const params = useParams();

    const abortController = useAbortController();

    const defaultColumns = [
        {
            // Build our expander column
            width: 30,
            id: 'expander', // Make sure it has an ID
            Header: ({ getToggleAllRowsExpandedProps, isAllRowsExpanded }) => (
                <>{/* <span {...getToggleAllRowsExpandedProps()}>{isAllRowsExpanded ? <IconChevronDown /> : <IconChevronRight />}</span> */}</>
            ),
            Cell: ({ row }) =>
                // Use the row.canExpand and row.getToggleRowExpandedProps prop getter
                // to build the toggle for expanding a row
                {
                    let isChecked = false;
                    let indeterminate = false;
                    if (row.subRows) {
                        // if all of the subrows are included in the selected items.`
                        const commonItems = _.intersectionBy(row.originalSubRows, selectedItems, 'id');
                        isChecked = commonItems.length === row.subRows.length;
                        indeterminate = commonItems.length && commonItems.length < row.subRows.length ? true : false;
                    }
                    return row.canExpand ? (
                        <Group>
                            {/* <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} /> */}

                            <div
                                {...row.getToggleRowExpandedProps({
                                    style: {
                                        // We can even use the row.depth property
                                        // and paddingLeft to indicate the depth
                                        // of the row
                                        // paddingLeft: `${row.depth * 2}rem`,
                                    },
                                })}>
                                {row.isExpanded ? <IconChevronDown /> : <IconChevronRight />}
                            </div>
                            <Checkbox checked={isChecked} indeterminate={indeterminate} onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked, row.subRows)}></Checkbox>
                        </Group>
                    ) : null;
                },
        },
        // {
        //     Header: 'Photo Code',
        //     accessor: 'instructions["Web Photography Code"]',
        //     sortType: 'alphanumeric',
        //     width: 150,
        // },
        // {
        //     Header: 'Style',
        //     accessor: 'seasonSort',
        //     sortType: 'alphanumeric',
        //     width: 100,
        // },
        // {
        //     Header: 'Multi Shot',
        //     accessor: 'multiShotFlag',
        //     sortType: 'alphanumeric',
        //     width: 100,
        //     show: true,
        // },
        // {
        //     Header: 'Status',
        //     accessor: 'styleCount',
        //     sortType: 'alphanumeric',
        // },
        // {
        //     Header: 'Session',
        //     accessor: 'studioSessionCodes',
        //     sortType: 'alphanumeric',
        // },
        // {
        //     Header: 'Name',
        //     accessor: 'instructions["Name"]',
        //     sortType: 'alphanumeric',
        //     show: true,
        // },
        // {
        //     Header: 'Notes',
        //     accessor: 'instructions["Web Photography Notes"]',
        //     sortType: 'alphanumeric',
        //     show: true,
        // },
        // {
        //     Header: 'Size',
        //     accessor: 'instructions["Web Photography Sample Size"]',
        //     sortType: 'alphanumeric',
        //     width: 100,
        //     show: true,
        // },
        // {
        //     Header: 'OTB Date',
        //     accessor: 'instructions["Web Stock OTB Date"]',
        //     sortType: 'alphanumeric',
        //     width: 80,
        //     show: true,
        // },
        // // {
        // //     Header: 'ODBMS APN (GTIN)',
        // //     accessor: 'instructions["ODBMS APN (GTIN)"]',
        // // },
        // {
        //     Header: 'Sample Notes',
        //     accessor: 'sampleNotes',
        //     sortType: 'alphanumeric',
        //     show: true,
        // },
        // {
        //     Header: 'Sample Grade',
        //     accessor: 'sampleGrade',
        //     sortType: 'alphanumeric',
        //     show: true,
        // },
        // {
        //     Header: 'Style',
        //     accessor: 'instructions["Web Photography Style"]',
        //     sortType: 'alphanumeric',
        //     width: 80,
        //     show: true,
        // },
        // // {
        // //     Header: 'Dept',
        // //     accessor: 'instructions["Dept"]',
        // // },
        // {
        //     Header: 'Department',
        //     accessor: 'instructions["departmentStr"]',
        //     sortType: 'alphanumeric',
        //     show: true,
        // },

        // {
        //   Header: 'Instructions',
        //   accessor: 'instructions',
        // },
    ];
    const [columns, setColumns] = useState(defaultColumns);
    // const columns = defaultColumns;
    const [hiddenColumns, setHiddenColumns] = useLocalStorage({
        key: 'oi-season-styles-hidden-columns',
        defaultValue: [...defaultColumns].filter((val) => Object.hasOwn(val, 'show') && val.show === false && val.accessor).map((val) => val.accessor),
    });

    const sampleFilter = useMemo(() => {
        return sampleFilters[params.id] ? sampleFilters[params.id].filter : { ...new SampleFilterModel() };
    }, [season, sampleFilters]);

    const setSampleFilter = useCallback(
        (filter) => {
            dispatch(setSampleFilters({ seasonId: params.id, filter }));
        },
        [season, sampleFilters, sampleFilter],
    );

    const [keywordInput, setKeywordInput] = useState('');
    const debouncedSetKeywordRef = useRef(null);
    const sampleFilterRef = useRef(sampleFilter);

    // updat the columns with company specific columns on the aggData Update
    useEffect(() => {
        var tmpCols = [
            ...defaultColumns,
            ...(aggData ? CompanyTableColumns[getCompany(aggData)?.code]?.seasonStyles || [] : []),
            {
                Header: '',
                accessor: 'action',
                width: 30,
            },
        ];

        logger.log(' COLUMNS:', tmpCols, getCompany(aggData)?.code);
        setColumns([...tmpCols]);
    }, [aggData, selectedItems]);

    const selectAllMenu = (
        <div>
            {/* <Button variant='default' onClick={(e) => onMenuItemClick(e)}>Create new Season</Button>
      <Button variant='default' onClick={(e) => onMenuItemClick(e)}>Add to Season</Button> */}
            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.CREATE_SESSION })}>
                Create Session
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_ASSIGN_STYLES_TO_SESSION })}>
                Assign to Session
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.REMOVE_SAMPLE, data: selectedItems })}>
                Remove from Event
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_BATCH_EDIT_STYLES, data: selectedItems })}>
                Batch Update Styles
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_CREATE_GROUP_SHOT, data: selectedItems })}>
                Create Group Shot
            </Button>

            <Button variant='default' onClick={(e) => onMenuItemClick({ type: SeasonEventType.SEASON_ADD_TO_GROUP_SHOT, data: selectedItems })}>
                Add to Group Shot
            </Button>

            <Button variant='default' onClick={(e) => onSelectAll(e)}>
                Deselect All
            </Button>
        </div>
    );

    const filterSamples = useCallback(() => {
        const styles = season?.styles || [];
        if (!styles.length) {
            // setIsLoading(false);
            setSampleData([]);
            return;
        }

        // Precompute lookups once per filter run (not once per row).
        const brandsSet = sampleFilter.brands?.length ? new Set(sampleFilter.brands) : null;
        const categoriesSet = sampleFilter.categories?.length ? new Set(sampleFilter.categories) : null;
        const photoCodeSet = sampleFilter.photoCode?.length ? new Set(sampleFilter.photoCode) : null;
        const sampleSizeSet = sampleFilter.sampleSize?.length ? new Set(sampleFilter.sampleSize) : null;
        const shotStyleSet = sampleFilter.shotStyle?.length ? new Set(sampleFilter.shotStyle) : null;
        const departmentsSet = sampleFilter.departments?.length ? new Set(sampleFilter.departments) : null;
        const channelsSet = sampleFilter.channels?.length ? new Set(sampleFilter.channels) : null;
        const sessionsSet = sampleFilter.sessions?.length ? new Set(sampleFilter.sessions) : null;
        const originsSet = sampleFilter.origin?.length ? new Set(sampleFilter.origin) : null;
        const keywordLower = sampleFilter.keyword?.length ? sampleFilter.keyword.toLowerCase() : '';

        const status = sampleFilter.status || {};
        const hasSession = status.hasSession;
        const statusKeys = Object.keys(status).filter((k) => k !== 'hasSession');

        const dateStart = sampleFilter.otbDate?.dateStart ? moment(sampleFilter.otbDate.dateStart).toDate() : null;
        const dateEnd = sampleFilter.otbDate?.dateEnd ? moment(sampleFilter.otbDate.dateEnd).toDate() : null;

        const scanDateStart = sampleFilter.scanDate?.dateStart ? moment(sampleFilter.scanDate.dateStart).toDate() : null;
        const scanDateEnd = sampleFilter.scanDate?.dateEnd ? moment(sampleFilter.scanDate.dateEnd).toDate() : null;
        const createdDateStart = sampleFilter.createdDate?.dateStart ? moment(sampleFilter.createdDate.dateStart).toDate() : null;
        const createdDateEnd = sampleFilter.createdDate?.dateEnd ? moment(sampleFilter.createdDate.dateEnd).toDate() : null;

        const parsePage = (val) => {
            const str = val?.toString().trim();
            return str ? Number(str) : null;
        };
        const pageStart = sampleFilter.pageRange ? parsePage(sampleFilter.pageRange.pageStart) : null;
        const pageEnd = sampleFilter.pageRange ? parsePage(sampleFilter.pageRange.pageEnd) : null;
        const pageFilterActive = pageStart !== null || pageEnd !== null;

        const columnAccessors = columns?.length ? columns.map((c) => c.accessor).filter(Boolean) : [];

        // Some columns use nested accessors like `instructions["Name"]`. Resolve those here.
        const resolveAccessorValue = (row, accessor) => {
            if (!accessor) return undefined;
            if (typeof accessor === 'function') return accessor(row);
            if (typeof accessor !== 'string') return row?.[accessor];

            // Common in this codebase: instructions["Some Key"] / instructions['Some Key']
            if (accessor.startsWith('instructions[')) {
                const m = accessor.match(/^instructions\[(["'])(.*)\1\]$/);
                if (m) return row?.instructions?.[m[2]];
            }

            // Dot-paths like "instructions.Name"
            if (accessor.includes('.')) return _.get(row, accessor);

            return row?.[accessor];
        };

        // Main filter pass: favor early returns to skip work ASAP.
        var data = styles.filter((sample) => {
            if (brandsSet && !brandsSet.has(sample.facet_brand)) return false;
            if (categoriesSet && !categoriesSet.has(sample.metadata_toplevelcategory)) return false;

            const instructions = sample.instructions || {};

            if (photoCodeSet && !photoCodeSet.has(instructions['Web Photography Code'])) return false;
            if (sampleSizeSet && !sampleSizeSet.has(instructions['Web Photography Sample Size'])) return false;
            if (shotStyleSet && !shotStyleSet.has(instructions['Web Photography Style'])) return false;
            if (departmentsSet && !departmentsSet.has(instructions['departmentStr'])) return false;

            if (channelsSet) {
                const sampleChannels = sample.channels || [];
                if (!sampleChannels.length) return false;
                if (!sampleChannels.some((ch) => channelsSet.has(ch))) return false;
            }

            if (originsSet && !originsSet.has(sample.origin)) return false;

            if (hasSession === '1') {
                const sampleSessions = sample.studioSessionCodes || [];
                if (sessionsSet && sessionsSet.size) {
                    if (!sampleSessions.length) return false;
                    if (!sampleSessions.some((s) => sessionsSet.has(s))) return false;
                } else {
                    // "Has Session = yes" with no session filters means "any session exists".
                    if (!sampleSessions.length) return false;
                }
            } else if (hasSession === '0') {
                if (sample.studioSessionCodes?.length) return false;
            }

            if (sampleFilter.multiShotFlag === '1' && sample.multiShotFlag !== 'Y') return false;
            if (sampleFilter.multiShotFlag === '0' && sample.multiShotFlag === 'Y') return false;

            if (sampleFilter.outfittingFlag === '1' && sample.outfittingFlag !== 'Y') return false;
            if (sampleFilter.outfittingFlag === '0' && sample.outfittingFlag === 'Y') return false;

            // the status key values represent
            // '' = matches all
            // 1 matches values of the sample key value > 0
            // 0 matches values of the sample key value < 1
            for (let i = 0; i < statusKeys.length; i++) {
                const key = statusKeys[i];
                const filterVal = status[key];

                // Skip if no filter is set (empty string, null, undefined)
                if (!filterVal && filterVal !== 0) continue; // Allow 0 but skip '', null, undefined

                const filterInt = parseInt(filterVal);

                // Skip if filter is not a valid number
                if (Number.isNaN(filterInt)) continue;

                const sampleInt = parseInt(sample[key]);
                const sampleValue = Number.isNaN(sampleInt) ? 0 : sampleInt; // Treat missing as 0

                if (filterInt === 1) {
                    // Filter = 1: only show items WITH values (> 0)
                    if (sampleValue <= 0) return false;
                } else if (filterInt === 0) {
                    // Filter = 0: only show items WITHOUT values (< 1, i.e., 0 or missing)
                    if (sampleValue >= 1) return false;
                }
                // Empty string matches all (already handled by continue above)
            }

            const hasOtbDate = sampleFilter.hasOtbDate;
            const otbIsSet = isSampleOtbSet(sample);
            const parsedOtb = otbIsSet ? parseSampleOtbMoment(getSampleOtbRaw(sample)).toDate() : null;

            if (hasOtbDate === '1' && !otbIsSet) return false;
            if (hasOtbDate === '0' && otbIsSet) return false;
            if (hasOtbDate === '0' && isGroupShotShellWithOnlyOtbChildren(sample, styles)) return false;

            if ((dateStart || dateEnd) && hasOtbDate !== '0') {
                if (!otbIsSet) return false;

                // When same start and end date, expand end to end-of-day so items on that date match
                let start = dateStart;
                let end = dateEnd;
                if (dateStart && dateEnd && dateStart.toDateString() === dateEnd.toDateString()) {
                    end = new Date(dateEnd);
                    end.setHours(23, 59, 59, 999);
                }

                if (start && parsedOtb < start) return false;
                if (end && parsedOtb > end) return false;
            }

            if (scanDateStart || scanDateEnd) {
                const rawScan = sample.scan?.scanned;
                if (!rawScan) return false;
                const scanDate = new Date(rawScan);
                // Treat invalid dates as non-matching
                if (Number.isNaN(scanDate.getTime())) return false;

                // When same start and end date, expand end to end-of-day so items on that date match
                let start = scanDateStart;
                let end = scanDateEnd;
                if (scanDateStart && scanDateEnd && scanDateStart.toDateString() === scanDateEnd.toDateString()) {
                    end = new Date(scanDateEnd);
                    end.setHours(23, 59, 59, 999);
                }

                if (start && scanDate < start) return false;
                if (end && scanDate > end) return false;
            }

            if (createdDateStart || createdDateEnd) {
                const rawCreated = sample.created;
                if (!rawCreated) return false;
                const createdMoment = moment(rawCreated, ['YYYY-MM-DDTHH:mm:ss.SSSSSS', 'YYYY-MM-DD-HH-mm-ss'], true);
                if (!createdMoment.isValid()) return false;
                const createdDate = createdMoment.toDate();

                let start = createdDateStart;
                let end = createdDateEnd;
                if (createdDateStart && createdDateEnd && createdDateStart.toDateString() === createdDateEnd.toDateString()) {
                    end = new Date(createdDateEnd);
                    end.setHours(23, 59, 59, 999);
                }

                if (start && createdDate < start) return false;
                if (end && createdDate > end) return false;
            }

            if (pageFilterActive) {
                const samplePage = parsePage(sample.pageNumber);
                if (samplePage === null) return false;
                if (pageStart !== null && pageEnd !== null) {
                    if (samplePage < pageStart || samplePage > pageEnd) return false;
                } else if (pageStart !== null) {
                    if (samplePage !== pageStart) return false;
                } else if (pageEnd !== null) {
                    if (samplePage > pageEnd) return false;
                }
            }

            if (keywordLower) {
                const contains = (v) => v?.toString().toLowerCase().includes(keywordLower);
                if (contains(instructions['Web Photography Code'])) return true;
                if (contains(sample.seasonSort)) return true;
                if (contains(instructions['Web Photography Notes'])) return true;
                if (contains(instructions['ODBMS APN (GTIN)'])) return true;
                if (contains(instructions['department'])) return true;
                if (contains(instructions.Name)) return true;

                if (columnAccessors.length) {
                    for (let i = 0; i < columnAccessors.length; i++) {
                        const accessor = columnAccessors[i];
                        const val = resolveAccessorValue(sample, accessor);
                        if (contains(val)) return true;
                    }
                }
                return false;
            }

            return true;
        });

        data = appendAssocParentsForFilteredChildren(data, styles);

        const { passesOtbFilter } = buildOtbFilterHelpers(sampleFilter, styles);
        const groupShotOptions = sampleFilter.hasOtbDate === '0' || sampleFilter.hasOtbDate === '1' ? { passesOtbFilter } : {};

        // set season styles to the data
        data = organiseGroupShots(data, styles, groupShotOptions);

        if (sampleFilter.groupBy && data) {
            if (sampleFilter.groupBy === 'parentId') {
                // Special handling for parentId grouping
                // Separate items into parents and orphans
                const parentsWithChildren = [];
                const orphanItems = [];

                // Build parentId -> children map and seasonSort -> item map (avoid repeated scans).
                const parentIdToChildren = new Map();
                const seasonSortToItem = new Map();
                data.forEach((item) => {
                    if (item.seasonSort) seasonSortToItem.set(item.seasonSort, item);
                    if (item.parentId) {
                        if (!parentIdToChildren.has(item.parentId)) parentIdToChildren.set(item.parentId, []);
                        parentIdToChildren.get(item.parentId).push(item);
                    }
                });

                parentIdToChildren.forEach((children, parentId) => {
                    const parentItem = seasonSortToItem.get(parentId) || styles.find((item) => item.seasonSort === parentId || item.stylenumber === parentId);
                    if (parentItem && children.length > 0) {
                        parentsWithChildren.push({
                            ...parentItem,
                            type: 'group',
                            name: parentItem.seasonSort || parentId,
                            subRows: children,
                            id: parentId,
                        });
                    }
                });

                // Sort grouped items to ensure consistent ordering (optional - by parentId/seasonSort)
                parentsWithChildren.sort((a, b) => {
                    const aSort = a.seasonSort || a.id;
                    const bSort = b.seasonSort || b.id;
                    return aSort.localeCompare(bSort, undefined, { numeric: true });
                });

                // Add items that are not parents and don't have parents (orphans)
                // But exclude children that should be hidden from top level
                const parentIdsSet = new Set(parentIdToChildren.keys());
                data.forEach((item) => {
                    if (!item.parentId && !parentIdsSet.has(item.seasonSort) && !item.isChildOfFiltered) {
                        orphanItems.push(item);
                    }
                });

                // Sort orphan items to ensure consistent ordering
                orphanItems.sort((a, b) => {
                    const aSort = a.seasonSort || a.id || '';
                    const bSort = b.seasonSort || b.id || '';
                    return aSort.localeCompare(bSort, undefined, { numeric: true });
                });

                // Grouped items first, then orphan items
                data = [...parentsWithChildren, ...orphanItems];
            } else {
                // Standard grouping for other fields: O(n) via Map (avoid repeated filter()).
                const groupBy = sampleFilter.groupBy;
                const groupMap = new Map();
                data.forEach((item) => {
                    const group = item[groupBy];
                    if (!groupMap.has(group)) groupMap.set(group, []);
                    groupMap.get(group).push(item);
                });
                data = Array.from(groupMap.entries()).map(([group, subRows]) => ({ type: 'group', name: group, subRows, id: group }));
            }
        }

        // If no grouping is applied, filter out children that should be hidden from top level
        if (!sampleFilter.groupBy) {
            data = data.filter((item) => !item.isChildOfFiltered);
        }

        if (data) {
            setSampleData(data);
            setIsLoading(false);
        }
    }, [
        sampleFilter.brands,
        sampleFilter.categories,
        setSampleData,
        season,
        sampleFilter.groupBy,
        sampleFilter.keyword,
        sampleFilter.departments,
        sampleFilter.photoCode,
        sampleFilter.sampleSize,
        sampleFilter.sessions,
        sampleFilter.shotStyle,
        sampleFilter.status,
        sampleFilter.channels,
        sampleFilter.multiShotFlag,
        sampleFilter.outfittingFlag,
        sampleFilter.otbDate,
        sampleFilter.hasOtbDate,
        sampleFilter.scanDate,
        sampleFilter.createdDate,
        sampleFilter.pageRange,
        sampleFilter.origin,
        columns,
    ]);

    // Request handler hide preloading
    useEffect(() => {
        logger.log('success', success);
        if (success) {
            switch (success.type) {
                case importMastersStylesToSeasonSuccess.toString(): {
                    openConfirmModal({
                        title: 'Styles imported',
                        children: <Text size='sm'>Your styles have been successfully imported would you like to view the styles now?</Text>,
                        labels: {
                            confirm: 'Yes, view Styles now',
                            cancel: 'Cancel',
                        },
                        onConfirm: () => setSampleImportModalOpen(false),
                    });
                    dispatch(fetchSeasonStyles(params.id, null, abortController.current.signal));

                    break;
                }

                case fetchSeasonDocumentsSuccess.toString(): {
                    // setIsLoading(false);
                    // dispatch(selectSeason({ ...season, styles: data }));

                    filterSamples();

                    break;
                }
                case fetchSeasonStylesSuccess.toString(): {
                    // dispatch(selectSeason({ ...season, styles: data }));

                    filterSamples();
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1000);
                    break;
                }
                case getSeasonSuccess.toString(): {
                    dispatch(fetchSeasonStyles(params.id, null, abortController.current.signal));
                    // dispatch(fetchSeasonDocuments(params.id, null, abortController.current.signal));
                    break;
                }
                default: {
                    break;
                }
            }
        }
    }, [success]);

    /**
     * Handles the list toggle display
     * @param {*} val
     */
    // const listToggleHandler = (val) => {
    //     navigate({ search: `?displayType=${val}` });
    // };

    /**
     * Effect to fetch the samples
     */
    // useEffect(() => {
    //     if ((!hasInit.current && season && season.id) || (season && season.id !== params.id)) {
    //         setTimeout(() => {
    //             dispatch(fetchSeasonStyles(params.id, user));
    //         }, 100);
    //         hasInit.current = true;
    //     }
    // }, [dispatch, hasInit, season, params.id, user]);

    useEffect(() => {
        //setSampleData(samples);

        // set the brands/season/category
        var brands = {};
        var categories = {};
        var seasons = {};
        var sampleSize = {};
        var shotStyle = {};
        var department = {};
        var sessions = {};
        var photoCode = {};
        var origins = {};

        season?.styles?.forEach((item, idx) => {
            brands[item.facet_brand] = item;
            categories[item.metadata_toplevelcategory] = item;
            seasons[item.facet_season] = item;
            if (item.origin) {
                origins[item.origin] = item;
            }

            if (item.instructions) {
                sampleSize[item.instructions['Web Photography Sample Size'] ?? ''] = item;
                shotStyle[item.instructions['Web Photography Style']] = item;
                department[item.instructions['departmentStr']] = item;

                if (item.studioSessionCodes) {
                    const sessionCodes = item.studioSessionCodes;
                    sessionCodes.forEach((code) => {
                        sessions[code.trim()] = item;
                    });
                }

                photoCode[item.instructions['Web Photography Code']] = item;
            }
        });

        setFilterItems({ brands, categories, seasons, sampleSize, shotStyle, department, sessions, photoCode, origins });

        filterSamples();
    }, [season?.styles, filterSamples]);

    /**
     * Effect to handle location change
     */
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        let displayType = params.get('displayType');
        logger.log('location change ', location, ' DISPLAY: ', displayType, params);
        // if display type changes
        if (displayType && displayType !== listView) setListView(displayType);
    }, [location, listView]);

    const onItemClick = (item) => {
        // we need to select the current sample
        // dispatch(selectSample(item));
        // openSampleDetail(item);
        // update the route
        // navigate(`/warehouse/samples/${item.stylenumber}`);
        // dispatch(selectSample(item));

        // openSampleDetail(item);
        // update the route
        // navigate(`/warehouse/feed/${item.stylenumber}`);

        // changed to show modal so we allow for photoCode edit
        // navigate(`/warehouse/styles/${item.seasonSort}`);

        // TODO ADD THIS BACK IN
        openStyleModal(item);
    };

    const onItemSelected = (e, item, selected, rows) => {
        var items = [...selectedItems];

        const pageItems = rows.map((val) => {
            return { ...val.original };
        });

        if (item.type && item.type === 'group') {
            // select all the sub items.
            let subItems = [...item.subRows];
            if (selected) {
                subItems.forEach((val) => {
                    selectItems(e, val, selected, pageItems, items);
                });
            } else {
                items = _.differenceBy(items, subItems, 'id');
            }

            // if(selected){
            //     items = items.concat(subItems);
            // }else{
            //     items = items.filter(val => !subItems.find(item => item.id === val.id))
            // }
        } else {
            // call general helper to select items
            selectItems(e, item, selected, pageItems, items);
        }

        setSelectedItems(items);
        //dispatch(selectTasks(items));
        //selectTask(items);
    };

    const onItemSelected2 = (e, item, selected, rows) => {
        var items = [...selectedItems];
        selectItems(
            e,
            item,
            selected,
            rows.map((val) => val.original),
            items,
        );
        // if the item is a group then push the elements into the group.
        // if (item.type && item.type === 'group') {
        //     if (selected) {
        //         items.push({ id: item.id });
        //         item.subRows.forEach((row) => {
        //             var tmpItem = items.find((val) => val.id === row.id);
        //             if (!tmpItem) items.push({ id: row.id });
        //         });
        //     } else {
        //         _.remove(items, (val) => {
        //             return val.id === item.id;
        //         });

        //         item.subRows.forEach((row) => {
        //             _.remove(items, (val) => {
        //                 return val.id === row.id;
        //             });
        //         });
        //     }
        // } else {
        //     if (selected) {
        //         if (!items.find((val) => item.id === val.id))
        //             items.push({ id: item.id });
        //     } else {
        //         _.remove(items, (val) => {
        //             return val.id === item.id;
        //         });
        //     }
        // }

        // selectSamples(items);
        setSelectedItems(items);
    };

    const onSelectAll = () => {
        // if there are items selected remove them
        if (selectedItems.length) {
            setSelectedItems([]);
            // dispatch(selectSamples([]));
        } else {
            setSelectedItems([...sampleData]);
            // dispatch(selectSamples([...sampleData]));
        }
    };

    const onMenuItemClick = (e) => {
        logger.log(e);
        switch (e.type) {
            case SeasonEventType.CREATE_SESSION: {
                openSessionModal();
                break;
            }
            case SeasonEventType.SEASON_ASSIGN_STYLES_TO_SESSION: {
                openAssignToSessionModal();
                break;
            }

            case SampleEventType.SAMPLE_ASSIGN_CAPTURES: {
                onItemClick(e.data);
                break;
            }

            case SampleEventType.SAMPLE_BUILD_OUTFIT: {
                navigate(`/warehouse/outfitter/create`);
                break;
            }

            case SampleEventType.SAMPLE_SHOW_SESSION: {
                navigate(`/sessions/${e.data}`);
                break;
            }

            case SampleEventType.SAMPLE_DELETE:
            case SeasonActions.REMOVE_SAMPLE: {
                openConfirmModal({
                    title: 'Style remove confirm',
                    children: (
                        <>
                            <Text size='sm'>Are you sure you want to remove the styles from this Event</Text>
                        </>
                    ),
                    labels: { confirm: 'Confirm', cancel: 'Cancel' },
                    onCancel: () => console.log('Cancel'),
                    onConfirm: () => {
                        var items = [];
                        var missCount = [];
                        e.data.forEach((val) => {
                            const tmpStyle = sampleData.find((item) => item.id === val.id);
                            if (!tmpStyle.studioSessionCodes || (tmpStyle.studioSessionCodes && tmpStyle.studioSessionCodes.length === 0)) {
                                items.push(tmpStyle);
                            } else {
                                missCount.push(val.id);
                            }
                        });

                        if (items.length) {
                            dispatch(removeStylesFromSeason(season, items));
                        }

                        closeAllModals();

                        if (missCount.length) {
                            openConfirmModal({
                                title: 'Unable to remove',
                                children: (
                                    <>
                                        <Text size='sm'>We weren't able to remove the following styles due to them being assigned to existing sessions.</Text>
                                    </>
                                ),
                                labels: { confirm: 'Confirm', cancel: 'Cancel' },
                                onCancel: () => console.log('Cancel'),
                                onConfirm: () => {
                                    closeAllModals();
                                },
                            });
                        }
                    },
                });

                break;
            }

            case SeasonEventType.SEASON_BATCH_EDIT_STYLES: {
                const payload = e.data.map((val) => {
                    const item = season.styles.find((o) => o.id === val.id);
                    return { ...item };
                });

                openModal({
                    title: 'Batch Update Styles',
                    size: 'xl',
                    children: (
                        <>
                            <BatchSeasonStyleEdit mode={ViewModes.EDIT} season={season} styles={payload} onCancel={closeAllModals} user={user} validate={{}} />
                        </>
                    ),
                });
                break;
            }

            case SeasonEventType.SEASON_CREATE_GROUP_SHOT: {
                logger.log('SEASON_CREATE_GROUP_SHOT', e.data);
                var styles = [];
                e.data.forEach((val) => {
                    // the format could be SEA-437110__71398501-PAGE8SHOT1 so we need to remove the last part of the id after the hyphen
                    // the last hyphen, only split if there is more than one hyphen
                    const id = val.id.split('-').length > 2 ? val.id.split('-').slice(0, -1).join('-') : val.id;
                    const item = season.styles.find((o) => o.id === id);
                    if (item) {
                        styles.push(item);
                    }
                });
                openModal({
                    title: 'Create Group Shot',
                    size: 'xl',
                    children: <GroupShotEdit season={season} styles={styles} onCancel={closeAllModals} user={user} />,
                });
                break;
            }

            case SeasonEventType.SEASON_ADD_TO_GROUP_SHOT: {
                const payload = e.data.map((val) => {
                    const item = season.styles.find((o) => o.id === val.id);
                    return { ...item };
                });
                const groupShots = season.styles
                    .filter((val) => val.assocStyles)
                    .map((val) => {
                        return { ...val };
                    });
                openModal({
                    title: 'Add Styles to Group Shot',
                    size: 'xl',
                    children: <AddStyleToGroupShot season={season} styles={payload} groupShots={groupShots} onCancel={closeAllModals} user={user} />,
                });
                break;
            }

            case SampleEventType.SAMPLE_REMOVE_FROM_GROUP_SHOT: {
                // const payload = e.data.map((val) => {
                //     const item = season.styles.find((o) => o.id === val.id);
                //     return { ...item };
                // });
                // show a confirm modal to remove the styles from the group shot
                openConfirmModal({
                    title: 'Remove Style from Group Shot',
                    labels: { confirm: 'Confirm', cancel: 'Cancel' },
                    children: (
                        <>
                            <Text size='sm'>Are you sure you want to remove the style from the group shot?</Text>
                        </>
                    ),
                    onCancel: () => console.log('Cancel'),
                    onConfirm: () => {
                        // remove the style from the group shot
                        const parentId = e.data.parentId;
                        var parentStyle = season.styles.find((val) => val.stylenumber === parentId);

                        if (parentStyle) {
                            var tmpStyle = { id: parentStyle.id, styleCode: parentStyle.stylenumber, stylenumber: parentStyle.stylenumber };
                            var assocStyles = parentStyle.assocStyles.split(',').map((val) => val.trim());
                            assocStyles = assocStyles.filter((val) => val.trim() !== e.data.stylenumber);
                            tmpStyle.assocStyles = assocStyles.join(',');
                            dispatch(updateSeasonStyle(season, tmpStyle));
                            closeAllModals();
                        }
                    },
                });
                break;
            }

            case SampleEventType.SAMPLE_VIEW_CAPTURES: {
                navigate(`/warehouse/styles/${e.data.stylenumber}/captures`);
                break;
            }

            default: {
                break;
            }
        }
    };

    const onCreateSessionSubmit = (vals) => {
        logger.log('onCreateSessionSumit', vals);
        var styles = [];
        const processedStyleIds = new Set(); // Track processed styles to avoid duplicates

        vals.styles.forEach((val) => {
            const style = season.styles.find((sample) => val === sample.id);

            if (style) {
                // Add the main style
                const styleObj = {
                    ...style,
                    // channel: vals.channel,
                    channels: [vals.channel], // add channels to the style
                    targetSort: style.seasonSort,
                    name: style.instructions['Name'],
                    descr: '',
                };
                styles.push(styleObj);
                processedStyleIds.add(style.id);

                // Check if the style has assocStyles and add them
                if (style.assocStyles) {
                    const assocStyleIds = style.assocStyles.split(',').map((id) => id.trim());
                    assocStyleIds.forEach((assocId) => {
                        // Only add if not already processed
                        if (!processedStyleIds.has(assocId)) {
                            const assocStyle = season.styles.find((sample) => assocId === sample.stylenumber);
                            if (assocStyle) {
                                styles.push({
                                    ...assocStyle,
                                    channels: [vals.channel], // add channels to the style
                                    targetSort: assocStyle.seasonSort,
                                    name: assocStyle.instructions['Name'],
                                    descr: '',
                                    // add the mainshot
                                    mainShot: style.stylenumber,
                                });
                                processedStyleIds.add(assocStyle.stylenumber);
                            }
                        }
                    });
                }
            }
        });

        logger.log('styles', styles, vals);

        dispatch(createSession({ ...vals, channels: [vals.channel], styles: styles }, user, season));
    };

    const openSessionModal = (styleArray) => {
        const data = styleArray ? styleArray : selectedItems;

        const styles = data.map((val, idx) => {
            let item = season.styles.find((style) => style.id === val.id);
            return item;
        });

        logger.log(styles);

        dispatch(selectSession(new SessionModel()));

        openModal({
            title: 'Create a new Session',
            size: 'xl',
            children: (
                <>
                    <SessionEdit
                        styles={styles}
                        availableStyles={season.styles.map((val) => ({ ...val, targetSort: val.seasonSort }))}
                        season={season}
                        onSubmit={onCreateSessionSubmit}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const openAssignToSessionModal = (styleArray) => {
        const data = styleArray ? styleArray : selectedItems;

        const styles = data.map((val, idx) => {
            // remove the parentId from the id because of the new grouping
            var tmpId = val.id.replace(/-[A-F0-9]{6}$/i, '');
            let item = season.styles.find((style) => style.id === tmpId);
            return item;
        });

        logger.log(styles);

        // dispatch(selectSession(new SessionModel()));

        openModal({
            title: 'Assign Styles to Session',
            size: 'lg',
            children: (
                <>
                    <AssignToSession
                        styles={styles}
                        availableStyles={season.styles.map((val) => ({ ...val, targetSort: val.seasonSort }))}
                        season={season}
                        // onSubmit={onCreateSessionSubmit}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const openStyleModal = (item) => {
        dispatch(selectSample(item));
        const childStyles = item.assocStyles?.split(',').map((val) => season.styles.find((style) => style.stylenumber === val.trim()));
        openModal({
            title: 'Sample Edit',
            size: 'xl',
            children: (
                <>
                    <StyleEdit
                        sample={{ ...item, childStyles: childStyles }}
                        onSubmit={(values) => {
                            // save the style
                            var sample = { ...values, styleCode: values.seasonSort, photoCode: values.photoCode };
                            if (values.channels.length > 0) {
                                sample.channels = values.channels.join(',');
                            }
                            if (values.assocStyles.length > 0) {
                                sample.assocStyles = values.assocStyles.join(',');
                            }
                            dispatch(updateSeasonStyle(season, sample));
                        }}
                        onCancel={() => {
                            closeAllModals();
                        }}
                    />
                </>
            ),
        });
    };

    const setFilterVars = (vals) => {
        logger.log(vals);
        setSampleFilter({ ...vals, pageIndex: 0 });
    };

    useEffect(() => {
        // filter the data.
        filterSamples();
    }, [filterSamples]);

    const getFilterCount = (val) => {
        var count = 0;
        const ignoreKeys = ['groupBy'];
        Object.entries(val).forEach(([key, value]) => {
            if (ignoreKeys.includes(key)) {
                return;
            }
            if (value?.length) {
                ++count;
            }
            if (key === 'status') {
                var statusCount = 0;
                Object.entries(value).forEach(([key, value]) => {
                    logger.log(key, value);
                    if (value && value.length) {
                        ++statusCount;
                    }
                });

                count += statusCount;
            }
            if (key === 'otbDate') {
                if (value.dateStart?.toString() || value.dateEnd?.toString()) {
                    ++count;
                }
            }

            if (key === 'scanDate') {
                if (value.dateStart?.toString() || value.dateEnd?.toString()) {
                    ++count;
                }
            }

            if (key === 'createdDate') {
                if (value.dateStart?.toString() || value.dateEnd?.toString()) {
                    ++count;
                }
            }

            if (key === 'pageRange') {
                if (value.pageStart.toString() || value.pageEnd.toString()) {
                    ++count;
                }
            }
        });

        return count;
    };

    useEffect(() => {
        const count = getFilterCount(sampleFilter);
        setFilterCount(count);
    }, [sampleFilter]);

    const onClearClick = (e) => {
        e.stopPropagation();
        e.nativeEvent.stopPropagation();
        const filter = new SampleFilterModel();
        filter.otbDate = { dateStart: '', dateEnd: '' };
        filter.scanDate = { dateStart: '', dateEnd: '' };
        filter.pageRange = { pageStart: '', pageEnd: '' };
        filter.createdDate = { dateStart: '', dateEnd: '' };
        setSampleFilter(filter);
        logger.log('CLEAR CLICK', e);
    };

    const filterButtonHandler = (e) => {
        logger.log('BUTTON CLICK', e, e.nativeEvent);
        setFilterOpen((o) => !o);
    };

    // const onSampleAction = (e) => {
    //     switch (e.type) {
    //         case SeasonActions.ASSIGN_SAMPLE: {
    //             openSampleAssign();
    //             break;
    //         }
    //     }
    // };

    // const openSampleAssign = () => {
    //     openModal({
    //         title: 'Apply Styles',
    //         size: 'xl',
    //         children: <>{/* <AssignSample season={season} /> */}</>,
    //     });
    // };

    // const openSampleDetail = (sample) => {
    //     openModal({
    //         title: 'Assign Style Captures',
    //         size: '100%',
    //         children: <>{/* <ShotAssign season={season} sample={sample} /> */}</>,
    //     });
    // };

    const rowMenuItems = [
        {
            handler: (data) => {
                openStyleModal(data);
            },
            label: 'Edit Style',
            icon: <IconEdit size={14} />,
        },
        {
            handler: (data) => {
                openSessionModal([data]);
            },
            label: 'Create Session',
            icon: <IconPlus size={14} />,
        },
        {
            handler: (data) => {
                openAssignToSessionModal([data]);
            },
            label: 'Assign to Session',
            icon: <IconFileSymlink size={14} />,
        },
        {
            handler: (data) => {
                onMenuItemClick({ e: SessionActions.REMOVE_SAMPLE, data: [data] });
            },
            label: 'Unassign',
            icon: <IconTrash size={14} />,
        },
        {
            handler: (data) => {
                onMenuItemClick({ type: SeasonEventType.SEASON_ADD_TO_GROUP_SHOT, data: [data] });
            },
            label: 'Add to Group Shot',
            icon: <IconFolderPlus size={14} />,
        },
    ];

    const onMastersImport = (action, data) => {
        logger.log('onMastersImport', action, data);

        dispatch(importMastersStyles(season, data));
    };

    const onSampleSave = (action, data) => {
        // refetch the seasons style.
        showNotification({
            title: 'Success',
            message: 'New Style created',
            position: 'top-center',
            color: 'teal',
        });

        // close the modal only if we aren't createing any more
        if (!displayPrefs.createAnotherStyleFlag) {
            setSampleModalOpen(false);
        }

        dispatch(fetchSeasonStyles(season.id, null, abortController.current.signal));
    };

    const columnFilterHandler = (type, data, isShown) => {
        const show = !isShown;
        const idx = hiddenColumns.indexOf(data.accessor);
        var cols = [...hiddenColumns];

        logger.log(cols, data, isShown, idx);
        // if we need to add
        if (!show && idx < 0) {
            cols.push(data.accessor);
        }

        if (!show && idx > -1) {
            cols.splice(idx, 1);
        }

        if (show && idx > -1) {
            cols.splice(idx, 1);
        }
        logger.log(' AFTER SPLCE', cols, data, isShown);
        setHiddenColumns([...cols]);
    };

    const onPrefChange = (val) => {
        logger.log(val);
        setDisplayPrefs({ createAnotherStyleFlag: val });
    };

    // Keep ref in sync
    useEffect(() => {
        sampleFilterRef.current = sampleFilter;
    }, [sampleFilter]);

    // Create debounced function
    useEffect(() => {
        const debounceDelay = sampleData && sampleData.length > 1000 ? 1000 : 200;
        debouncedSetKeywordRef.current = _.debounce((keyword) => {
            setSampleFilter({
                ...sampleFilterRef.current,
                keyword: keyword,
            });
        }, debounceDelay); // Wait 300ms after typing stops

        return () => {
            if (debouncedSetKeywordRef.current) {
                debouncedSetKeywordRef.current.cancel();
            }
        };
    }, [setSampleFilter]);

    // Sync input with filter
    useEffect(() => {
        if (sampleFilter.keyword !== keywordInput) {
            setKeywordInput(sampleFilter.keyword || '');
        }
    }, [sampleFilter.keyword]);

    return (
        <div style={{ height: '100%' }}>
            <Box
                px='lg'
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                    position: 'relative',
                }}>
                <Group className='container-action-bar' sx={{ width: '100%' }} position='apart' height={'100%'} pt='xl' pb={'sm'} mb={'sm'}>
                    <Group>
                        <CheckboxDropdown selectedItems={selectedItems} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} />
                        <Input
                            value={keywordInput}
                            sx={{ width: 250 }}
                            onChange={(e) =>
                                // setSampleFilter({
                                //     ...sampleFilter,
                                //     keyword: e.currentTarget.value,
                                //     pageIndex: 0,
                                // })

                                {
                                    const value = e.currentTarget.value;
                                    setKeywordInput(value); // Update immediately for responsive UI
                                    if (debouncedSetKeywordRef.current) {
                                        debouncedSetKeywordRef.current(value); // Debounce filter update
                                    }
                                }
                            }
                            placeholder={`Search across ${season?.styles?.length ? season.styles.length : ''} Styles`}
                            rightSection={
                                <ActionIcon
                                    onClick={() =>
                                        setSampleFilter({
                                            ...sampleFilter,
                                            keyword: '',
                                        })
                                    }>
                                    {sampleFilter.keyword.length ? <IconX size={14} /> : null}
                                </ActionIcon>
                            }
                            icon={<IconSearch />}
                        />

                        <Text size='sm'>
                            Total{' '}
                            <strong>
                                {sampleData?.length} of {season?.styles?.length}
                            </strong>{' '}
                        </Text>

                        {/* <Button
                            onClick={() =>
                                onSampleAction({
                                    type: SeasonActions.ASSIGN_SAMPLE,
                                })
                            }
                            leftIcon={<IconPlus size={14} />}
                            variant={'light'}>
                            Assign
                        </Button> */}
                    </Group>

                    <Group>
                        {/* <Button variant='light' leftIcon={<IconPlus size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />} onClick={() => setSampleModalOpen(true)}>
                            Create Style
                        </Button> */}

                        <Menu shadow='md' width={200}>
                            <Menu.Target>
                                <Button variant='light' leftIcon={<IconPlus size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />}>
                                    Add Style
                                </Button>
                            </Menu.Target>

                            <Menu.Dropdown>
                                <Menu.Item onClick={() => setSampleModalOpen(true)} icon={<IconPlus size={14} />}>
                                    Create Single Style
                                </Menu.Item>
                                <Menu.Item onClick={() => setSampleImportModalOpen(true)} icon={<IconDatabaseImport size={14} />}>
                                    Import from Masters
                                </Menu.Item>
                            </Menu.Dropdown>
                        </Menu>

                        <Popover shadow='sm' position='bottom-end' opened={filterOpen} onClose={() => setFilterOpen(false)} width={600} withArrow closeOnClickOutside={true}>
                            <Popover.Target>
                                <div>
                                    <FilterButton onClick={filterButtonHandler} onClear={onClearClick} count={filterCount} />
                                </div>
                            </Popover.Target>

                            <Popover.Dropdown className='filter-panel-dropdown-wrapper'>
                                <Box shadow='xs' style={{ width: '100%' }}>
                                    <FilterPanel
                                        company={company}
                                        filter={sampleFilter}
                                        onCancel={() => setFilterOpen(false)}
                                        onApply={(vals) => {
                                            setFilterVars(vals);
                                            setFilterOpen(false);
                                        }}
                                        filterItems={filterItems}
                                    />
                                </Box>
                            </Popover.Dropdown>
                        </Popover>
                        <Select
                            style={{ width: 150 }}
                            placeholder='Group By'
                            clearable
                            value={sampleFilter.groupBy}
                            onChange={(val) =>
                                setFilterVars({
                                    ...sampleFilter,
                                    groupBy: val,
                                })
                            }
                            data={[
                                { value: '', label: 'No Group' },

                                {
                                    value: 'pageNumber',
                                    label: 'Group by Page',
                                },
                                // {
                                //     value: 'department',
                                //     label: 'Group by Department',
                                // },
                                // {
                                //     value: 'status',
                                //     label: 'Group by Status',
                                // }
                            ]}
                        />
                        <ColumnFilterMenu columns={columns} hiddenColumns={hiddenColumns} onChange={(val, data, isShown) => columnFilterHandler(val, data, isShown)} />
                        {/* need to add an export to csv icon button */}

                        <Tooltip label='Export to CSV'>
                            <div>
                                <CSVGenerator
                                    ignoreKeys={'captures'}
                                    flattenKeys={'instructions'}
                                    data={sampleData ?? []}
                                    label=''
                                    filename={`event-${season?.id}-styles-export-${moment().format('YYYY-MM-DD-HH-mm-ss')}`}
                                    columns={generateColKeys(columns) ?? []}
                                    icon={<IconTableExport size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />}
                                />
                            </div>
                        </Tooltip>
                        {/* <Select
                            placeholder='Group By'
                            value={sampleFilter.groupBy}
                            onChange={(val) =>
                                setSampleFilter({
                                    ...sampleFilter,
                                    groupBy: val,
                                })
                            }
                            data={[
                                { value: '', label: 'No Group' },
                                {
                                    value: 'styleNumber',
                                    label: 'Group by Style',
                                },
                                {
                                    value: 'colourName',
                                    label: 'Group by Colour',
                                },
                            ]}
                        /> */}
                    </Group>
                </Group>

                {/* <ScrollArea style={{height:500}} > */}

                {season && sampleData ? (
                    <Box
                        sx={(theme) => ({ flexGrow: 1, overflow: 'auto', marginRight: -theme.spacing.xl })}
                        className={
                            sampleFilter.groupBy && sampleFilter.groupBy.length ? 'main-container-content show-data-grouped' : 'main-container-content show-data-grouped-hidden show-grouped-children'
                        }>
                        {listView === ListViewOption.LIST ? (
                            // <Box sx={(theme) => ({ '.h-scroll-table-container': { paddingRight: theme.spacing.xl }, height: sampleData.length !== 0 ? 'auto' : '100%' })}>
                            <SampleList
                                data={sampleData}
                                onItemClick={onItemClick}
                                onMenuItemClick={onMenuItemClick}
                                onItemSelected={onItemSelected}
                                onStatusClick={onStatusClick}
                                selectedItems={selectedItems}
                                filter={sampleFilter}
                                loading={isLoading}
                                actionMenu={rowMenuItems}
                                paginationSize={200}
                                setFilter={setSampleFilter}
                                columns={columns}
                                allowAssignCapture={false}
                                hiddenColumns={hiddenColumns}
                                overrideGroupBy={false}
                                type='season'
                                aggData={aggData}
                            />
                        ) : (
                            // </Box>
                            <SampleGrid data={sampleData} onItemClick={onItemClick} onItemSelected={onItemSelected} selectedItems={selectedItems} />
                        )}
                    </Box>
                ) : null}

                {sampleData && sampleData.length === 0 && !isLoading ? (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: 200,
                        }}>
                        <EmptyState />
                    </Box>
                ) : null}

                {/* </ScrollArea> */}

                {/* {filterOpen ? (
                    <Box
                        style={{
                            backgroundColor: '#000',
                            opacity: '0.05',
                            position: 'absolute',
                            top: '155px',
                            right: 0,
                            bottom: 0,
                            left: '0px',
                            zIndex:2
                        }}></Box>
                ) : null} */}

                <Modal withCloseButton={true} size={'lg'} title='Create a new Style' opened={sampleModalOpen} trapFocus={true} onClose={() => setSampleModalOpen(false)}>
                    <SampleEdit
                        createAnotherFlag={displayPrefs.createAnotherStyleFlag}
                        season={season}
                        onCancel={() => setSampleModalOpen(false)}
                        onSampleSave={() => onSampleSave()}
                        onPrefChange={(val) => onPrefChange(val)}
                    />
                </Modal>

                <Modal withCloseButton={true} size={'90%'} title='Import Styles from Masters' opened={sampleImportModalOpen} trapFocus={true} onClose={() => setSampleImportModalOpen(false)}>
                    <MastersStyleImport
                        createAnotherFlag={displayPrefs.createAnotherStyleFlag}
                        season={season}
                        onCancel={() => setSampleModalOpen(false)}
                        onAction={(action, data) => onMastersImport(action, data)}
                        onPrefChange={(val) => onPrefChange(val)}
                    />
                </Modal>

                <Modal withCloseButton={true} size={'lg'} title='Batch Upload Samples' opened={sampleUploadShown} trapFocus={true} onClose={() => setSampleUploadShown(false)}>
                    <SamplesUpload />
                </Modal>
            </Box>
        </div>
    );
};

// const FilterPanel = ({ onCancel, onApply, filter, filterItems }) => {
//     logger.log(filter);
//     const form = useForm({
//         initialValues: {
//             ...filter,
//             otbDate: {
//                 dateStart: filter.otbDate?.dateStart?.toString().length ? moment(filter.otbDate?.dateStart).toDate() : '',
//                 dateEnd: filter.otbDate?.dateEnd?.toString().length ? moment(filter.otbDate?.dateEnd).toDate() : '',
//             },
//         },
//     });

//     logger.log(form.values);

//     // logger.log(filter, filterItems, form.values);
//     // useEffect(() => {
//     //     if (filter && form) {
//     //         form.setValues({ ...filter });
//     //     }
//     // }, [filter, form]);

//     const getFilterVars = useCallback(
//         (key) => {
//             var res = [];
//             if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
//             return res.sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
//         },
//         [filter, filterItems],
//     );

//     const onSegmentChange = (e) => {
//         logger.log(e);
//     };

//     return (
//         <Box shadow='xs' style={{ width: '100%' }}>
//             <form onSubmit={form.onSubmit((values) => onApply(values))}>
//                 <Box pr={'md'} style={{ height: 400, overflow: 'auto', marginRight: -15 }}>
//                     <FormInputWrapper label='Photo Code' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('photoCode')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('photoCode')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Sample Size' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('sampleSize')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('sampleSize')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Style' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('shotStyle')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('shotStyle')} />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Department' labelWidth={'120px'}>
//                         <MultiSelect data={getFilterVars('department')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('departments')} />
//                     </FormInputWrapper>
//                     {/* <FormInputWrapper label='Sessions' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={getFilterVars('sessions')}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('sessions')}
//                     />
//                 </FormInputWrapper> */}
//                     {/* <FormInputWrapper label='Status' id='input-brands' labelWidth={'120px'}>
//                     <Stack>
//                         <Checkbox label='Sample Acquired' {...form.getInputProps('status.sampleCount', { type: 'checkbox' })} />
//                         <Checkbox label='Has Photography' {...form.getInputProps('status.photographyCount', { type: 'checkbox' })} />
//                         <Checkbox label='Has Tasks' {...form.getInputProps('status.taskCount', { type: 'checkbox' })} />
//                         <Checkbox label='Tasks Completed' {...form.getInputProps('status.completedTaskCount', { type: 'checkbox' })} />
//                     </Stack>

//                 </FormInputWrapper> */}
//                     <FormInputWrapper label='OTB Date' id='input-shootdate' labelWidth={'120px'}>
//                         <Group noWrap>
//                             <CustomDatePicker sx={{ width: 190 }} placeholder='From OTB Date' {...form.getInputProps('otbDate.dateStart')} />
//                             <Text>to</Text>
//                             <CustomDatePicker sx={{ width: 190 }} placeholder='To OTB Date' {...form.getInputProps('otbDate.dateEnd')} />
//                         </Group>
//                     </FormInputWrapper>

//                     <Divider />
//                     <FormInputWrapper label='Has Session' labelWidth={'120px'}>
//                         <Box sx={{ width: '100%' }}>
//                             <SegmentedControl
//                                 sx={{ flexShrink: 0 }}
//                                 data={[
//                                     { label: 'All', value: '' },
//                                     { label: 'Yes', value: '1' },
//                                     { label: 'No', value: '0' },
//                                 ]}
//                                 placeholder='Has Session'
//                                 onChange={(e) => onSegmentChange(e)}
//                                 {...form.getInputProps('status.hasSession')}
//                             />

//                             {form.values.status.hasSession === '1' ? (
//                                 <MultiSelect
//                                     mt={'sm'}
//                                     sx={{ flexGrow: `1 !important` }}
//                                     data={getFilterVars('sessions')}
//                                     label=''
//                                     placeholder='Pick all that you like'
//                                     searchable
//                                     nothingFound='Nothing found'
//                                     {...form.getInputProps('sessions')}
//                                 />
//                             ) : null}
//                         </Box>
//                     </FormInputWrapper>
//                     <Divider />
//                     <FormInputWrapper label='Multi Shot' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Photography'
//                             {...form.getInputProps('multiShotFlag')}
//                         />
//                     </FormInputWrapper>
//                     <FormInputWrapper label='Sample Acquired' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Sample Acquired'
//                             {...form.getInputProps('status.sampleCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Has Photography' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Photography'
//                             {...form.getInputProps('status.photographyCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Has Tasks' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Has Tasks'
//                             {...form.getInputProps('status.taskCount')}
//                         />
//                     </FormInputWrapper>

//                     <FormInputWrapper label='Tasks Complete' labelWidth={'120px'}>
//                         <SegmentedControl
//                             data={[
//                                 { label: 'All', value: '' },
//                                 { label: 'Yes', value: '1' },
//                                 { label: 'No', value: '0' },
//                             ]}
//                             placeholder='Tasks Complete'
//                             {...form.getInputProps('status.taskCompleteCount')}
//                         />
//                     </FormInputWrapper>

//                     {/* <FormInputWrapper label='Brands' id='input-brands' labelWidth={'120px'}>
//                     <MultiSelect data={getFilterVars('brands')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('brands')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Category' id='input-category' labelWidth={'120px'}>
//                     <MultiSelect data={getFilterVars('categories')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('categories')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Department' id='input-department' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('department')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Location' id='input-location' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('location')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Status' id='input-status' labelWidth={'120px'}>
//                     <MultiSelect
//                         data={['React', 'Angular', 'Svelte', 'Vue', 'Riot', 'Next.js', 'Blitz.js']}
//                         label=''
//                         placeholder='Pick all that you like'
//                         searchable
//                         nothingFound='Nothing found'
//                         {...form.getInputProps('status')}
//                     />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Colour' id='input-colour' labelWidth={'120px'}>
//                     <ColorInput placeholder='Pick color' {...form.getInputProps('colour')} />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Assigned Product' id='input-colour' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Part of a Season' id='input-assigned-product' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper>

//                 <FormInputWrapper label='Part of an Outfit' id='input-assigned-season' labelWidth={'120px'}>
//                     <NativeSelect data={['', 'Yes', 'No']} placeholder='Assigned Product' withAsterisk />
//                 </FormInputWrapper> */}
//                 </Box>
//                 <Divider />
//                 <Group position='apart' mt='sm'>
//                     <Button variant='subtle' component='button' size='sm' onClick={() => onCancel()}>
//                         Cancel
//                     </Button>
//                     <Button type='submit' size='sm'>
//                         Apply
//                     </Button>
//                 </Group>
//             </form>
//         </Box>
//     );
// };

const mapStateToProps = (state, props) => {
    logger.log(state, props);
    return {
        user: state.auth.user,
        aggData: state.appReducer.aggData,
        season: state.seasonReducer.selectedSeason,
        sample: state.warehouse.selectedSample,
        samples: state.warehouse.samples,
        selectedSamples: state.seasonReducer.selectedSamples,
        success: state.seasonReducer.success,
        sampleFilters: state.seasonReducer.seasonSampleFilters,
        displayPrefs: state.seasonReducer.displayPrefs,
        // sampleFilter: state.warehouse.sampleFilter,
        error: state.auth.error,
    };
};

const mapDispatchToProps = {
    selectSamples: selectSamples,
    setSampleFilters: setSeasonSampleFilters,
    setDisplayPrefs: setDisplayPrefs,
};

export default connect(mapStateToProps, mapDispatchToProps)(SeasonTabStyles);
